// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Compact text card (row / list view) ── */
.pll-compact-card {
  position: relative;
  background: #fff;
  border: none;
  border-radius: 12px;
  padding: 8px 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 84px;
  box-sizing: border-box;
  overflow: hidden;
  user-select: none;
}

.pll-compact-card:hover {
  box-shadow: 0 4px 14px rgba(8, 96, 230, 0.18);
  background: #f5f9ff;
}

.pll-compact-card.pll-card-disabled {
  opacity: 0.6;
  pointer-events: none;
}

.pll-compact-card.pll-card-disabled:hover {
  box-shadow: none;
  background: #fff;
}

.pll-compact-card.dark {
  background: var(--dark-blue);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.pll-compact-card.dark .pll-name { color: #fff; }
.pll-compact-card.dark .pll-sub,
.pll-compact-card.dark .pll-bundle-variants { color: #a0a8c8; }


.pll-name {
  font-weight: 700;
  font-size: 0.75rem;
  color: #111;
  line-height: 1.3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  margin: 0;
  text-align: center;
}

.pll-sub {
  font-size: 0.75rem;
  color: #666;
  margin: 0;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pll-bundle-variants {
  font-size: 0.688rem;
  color: #888;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pll-price {
  font-size: 0.75rem;
  color: #0860E6;
  font-weight: 700;
  margin: 4px 0 0;
  text-align: center;
}

.pll-variants {
  font-size: 0.75rem;
  color: #0860E6;
  font-weight: 600;
  margin: 4px 0 0;
  text-align: center;
}

.pll-food-dot {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.pll-status-text {
  font-size: 0.688rem;
  font-weight: 500;
  color: #9ca3af;
  text-align: center;
  margin: 2px 0 0;
  line-height: 1.4;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.pll-includes-text {
  font-size: 0.688rem;
  font-weight: 600;
  color: #6366f1;
  margin: 0;
  text-align: center;
  line-height: 1;
}

.pll-loader-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 8px;
  z-index: 2;
}

.productListCard, .productListCardLeftContainer, .productListCardImage,
.productListCardText, .productListCardTextInnerContainer,
.productListCardButton { /* no-op */ }

.combo-badge-list {
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  background-color: #0860E6;
  padding: 2px 6px;
  border-radius: 4px;
  line-height: 1.4;
  white-space: nowrap;
  flex-shrink: 0;
}

.bundle-variants-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.bundle-variant-chip {
  font-size: 10px;
  color: #374151;
  background-color: #F3F4F6;
  border: 1px solid #E5E7EB;
  padding: 1px 6px;
  border-radius: 10px;
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Add button (shown when onTileClick is provided) ── */
.pll-add-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1.5px solid #0860E6;
  background: transparent;
  color: #0860E6;
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;
}

.pll-add-btn:hover {
  background: #0860E6;
  color: #fff;
}

.pll-add-btn:disabled {
  border-color: #cbd5e1;
  color: #cbd5e1;
  cursor: not-allowed;
}

.pll-compact-card.dark .pll-add-btn {
  border-color: #60a5fa;
  color: #60a5fa;
}

.pll-compact-card.dark .pll-add-btn:hover {
  background: #60a5fa;
  color: #1e293b;
}

/* ── Dark theme ── */
.dark .pll-compact-card {
  background: #1e293b;
}

.dark .pll-compact-card:hover {
  background: #334155;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
}

.dark .pll-compact-card.pll-card-disabled:hover {
  background: #1e293b;
}

.dark .pll-name {
  color: #f1f5f9;
}

.dark .pll-sub {
  color: #94a3b8;
}

.dark .pll-bundle-variants {
  color: #64748b;
}

.dark .pll-status-text {
  color: #64748b;
}

.dark .pll-loader-overlay {
  background: rgba(30, 41, 59, 0.7);
}

.dark .bundle-variant-chip {
  color: #94a3b8;
  background-color: #0f172a;
  border-color: #334155;
}
`, "",{"version":3,"sources":["webpack://./client/src/customComponents/ProductListLayout/ProductListLayout.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA,mCAAmC,WAAW,EAAE;AAChD;8CAC8C,cAAc,EAAE;;;AAG9D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;yBAEyB,UAAU,EAAE;;AAErC;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":["/* ── Compact text card (row / list view) ── */\n.pll-compact-card {\n  position: relative;\n  background: #fff;\n  border: none;\n  border-radius: 12px;\n  padding: 8px 10px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  min-height: 84px;\n  box-sizing: border-box;\n  overflow: hidden;\n  user-select: none;\n}\n\n.pll-compact-card:hover {\n  box-shadow: 0 4px 14px rgba(8, 96, 230, 0.18);\n  background: #f5f9ff;\n}\n\n.pll-compact-card.pll-card-disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.pll-compact-card.pll-card-disabled:hover {\n  box-shadow: none;\n  background: #fff;\n}\n\n.pll-compact-card.dark {\n  background: var(--dark-blue);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.pll-compact-card.dark .pll-name { color: #fff; }\n.pll-compact-card.dark .pll-sub,\n.pll-compact-card.dark .pll-bundle-variants { color: #a0a8c8; }\n\n\n.pll-name {\n  font-weight: 700;\n  font-size: 0.75rem;\n  color: #111;\n  line-height: 1.3;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  margin: 0;\n  text-align: center;\n}\n\n.pll-sub {\n  font-size: 0.75rem;\n  color: #666;\n  margin: 0;\n  font-weight: 400;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pll-bundle-variants {\n  font-size: 0.688rem;\n  color: #888;\n  margin: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.pll-price {\n  font-size: 0.75rem;\n  color: #0860E6;\n  font-weight: 700;\n  margin: 4px 0 0;\n  text-align: center;\n}\n\n.pll-variants {\n  font-size: 0.75rem;\n  color: #0860E6;\n  font-weight: 600;\n  margin: 4px 0 0;\n  text-align: center;\n}\n\n.pll-food-dot {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.pll-status-text {\n  font-size: 0.688rem;\n  font-weight: 500;\n  color: #9ca3af;\n  text-align: center;\n  margin: 2px 0 0;\n  line-height: 1.4;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.pll-includes-text {\n  font-size: 0.688rem;\n  font-weight: 600;\n  color: #6366f1;\n  margin: 0;\n  text-align: center;\n  line-height: 1;\n}\n\n.pll-loader-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.6);\n  border-radius: 8px;\n  z-index: 2;\n}\n\n.productListCard, .productListCardLeftContainer, .productListCardImage,\n.productListCardText, .productListCardTextInnerContainer,\n.productListCardButton { /* no-op */ }\n\n.combo-badge-list {\n  font-size: 10px;\n  font-weight: 600;\n  color: #fff;\n  background-color: #0860E6;\n  padding: 2px 6px;\n  border-radius: 4px;\n  line-height: 1.4;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.bundle-variants-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.bundle-variant-chip {\n  font-size: 10px;\n  color: #374151;\n  background-color: #F3F4F6;\n  border: 1px solid #E5E7EB;\n  padding: 1px 6px;\n  border-radius: 10px;\n  white-space: nowrap;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── Add button (shown when onTileClick is provided) ── */\n.pll-add-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 4px;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 1.5px solid #0860E6;\n  background: transparent;\n  color: #0860E6;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s, color 0.15s;\n}\n\n.pll-add-btn:hover {\n  background: #0860E6;\n  color: #fff;\n}\n\n.pll-add-btn:disabled {\n  border-color: #cbd5e1;\n  color: #cbd5e1;\n  cursor: not-allowed;\n}\n\n.pll-compact-card.dark .pll-add-btn {\n  border-color: #60a5fa;\n  color: #60a5fa;\n}\n\n.pll-compact-card.dark .pll-add-btn:hover {\n  background: #60a5fa;\n  color: #1e293b;\n}\n\n/* ── Dark theme ── */\n.dark .pll-compact-card {\n  background: #1e293b;\n}\n\n.dark .pll-compact-card:hover {\n  background: #334155;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);\n}\n\n.dark .pll-compact-card.pll-card-disabled:hover {\n  background: #1e293b;\n}\n\n.dark .pll-name {\n  color: #f1f5f9;\n}\n\n.dark .pll-sub {\n  color: #94a3b8;\n}\n\n.dark .pll-bundle-variants {\n  color: #64748b;\n}\n\n.dark .pll-status-text {\n  color: #64748b;\n}\n\n.dark .pll-loader-overlay {\n  background: rgba(30, 41, 59, 0.7);\n}\n\n.dark .bundle-variant-chip {\n  color: #94a3b8;\n  background-color: #0f172a;\n  border-color: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
